import React from 'react';

const requiredFieldIsMissing = {
  title: value => !value,
  description: value => !value,
  published: value => value === null || value === undefined,
  contentType: value => !value,
  science: value => value === '' || value === null || value === undefined,
  facultyDepartment: value => !value
};

const visibility = (status, label, color) => (collection) => {
  const hasVisibility = collection?.visibility?.includes(status);
  if (hasVisibility) {
    return {
      label: label,
      ariaLabel: `collection_${label}_aria`,
      color: color || 'blue'
    };
  }
  return null;
};

const missingDetails = (collection) => {
  const hasMissingDetails = Object.entries(requiredFieldIsMissing).some(([field, isMissing]) =>
    isMissing(collection?.[field])
  );

  if (hasMissingDetails) {
    return {
      label: 'tag_validation_failed',
      ariaLabel: 'collection_tag_validation_failed_aria',
      filterAriaLabel: 'collection_tag_button_validation_failed_aria',
      color: 'red'
    };
  }
  return null;
};

const useCollectionTags = (collections = []) => {
  const tagFunctions = [
    missingDetails,
    visibility('status_private', 'tag_private'),
    visibility('status_published', 'tag_published'),
    visibility('status_unlisted', 'tag_unlisted'),
    visibility('status_moodle', 'tag_moodle', 'grey'),
  ];

  const tags = collections.map(collection => {
    return tagFunctions
      .flatMap(tagFunction => tagFunction(collection))
      .filter(tag => tag);
  });
  return tags;
};

export default useCollectionTags;
